const getNotificationLicensedUserInfo = user => {
  const {
    info,
    professionalInfo
  } = user;

  if (!professionalInfo) {
    throw new Error(`Professional info not found for user ${user.id} when getting notification licensed user info`);
  }

  const {
    firstName,
    lastName,
    email,
    phone
  } = info;
  const notificationPrescriber = {
    firstName,
    lastName,
    email,
    phone,
    id: user.id,
    license: professionalInfo.title
  };
  return notificationPrescriber;
};

export { getNotificationLicensedUserInfo };
